/* eslint-disable no-undef */
export default () => {
  function canUseWebP() {
    const elem = document.createElement('canvas');
    if (elem.getContext && elem.getContext('2d')) {
      return elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
    }
    return false;
  }

  if (canUseWebP() === false) {
    const $items = $('.lazy[data-bg]');
    $items.each((index, item) => {
      const $item = $(item);
      const srcBgFallback = $item.attr('data-bg-fallback');

      if (srcBgFallback) {
        console.log(srcBgFallback)
        $item.attr('data-bg', srcBgFallback);
      }
    });
  }

  // eslint-disable-next-line no-unused-vars
  const lazyLoad = new LazyLoad({
    elements_selector: '.lazy',
  });
};
